<template>
  <Modal
    :open="props.open"
    @close-modal="$emit('close-modal')"
    customHeight="h-auto"
    customWidth="lg:w-120"
  >
    <template #modal-header>
      <div>
        <div class="flex items-center">
          <Icon name="Info" class="w-4 h-4 mr-2 stroke-info" />
          <div class="text-sm font-inter font-semibold text-info">Info</div>
        </div>
        <div class="font-league tracking-[-.56px] font-semibold text-[1.75rem] text-strongest">
          {{ props.label }}
        </div>
      </div>
    </template>

    <template #modal-body>
      <div class="p-6 text-strong text-lg">
        {{ props.additional_info }}
      </div>
    </template>
    <template #modal-footer>
      <div class="flex justify-end gap-2">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="sm" class="">
          <template #label>Close</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
//IMPORTS
import { Modal, Icon, Button } from "@/components";

//EMITS AND PROPS
const emit = defineEmits(["close-modal", "confirm"]);
const props = defineProps({
  open: { type: Boolean, required: true },
  additional_info: { type: String, default: "" },
  label: { type: String, default: "Additional Information" },
});
</script>
